// @file The store for handling guided templates on surface
import { isAppUsing } from '@@/bits/flip'
import { useSurfaceOnboardingPanelStore } from '@@/pinia/surface_onboarding_panel'
import { defineStore } from 'pinia'
import { computed } from 'vue'

export const useSurfaceGuidedTemplateStore = defineStore('surfaceGuidedTemplateStore', () => {
  const surfaceOnboardingPanelStore = useSurfaceOnboardingPanelStore()

  /// TODO: update prop wallCreatedFromType to include guided_templates and add an isGuidedPanel to match isGalleryTemplatePanel ENG-12934
  const xOnboardingGuidedPanel = computed(() => {
    // TODO: change this to use isGuidedPanel once the backend is updated
    return surfaceOnboardingPanelStore.showOnboardingPanel && isAppUsing('guidedTemplates')
  })
  return {
    xOnboardingGuidedPanel,
  }
})
